import { Component, OnInit, VERSION } from '@angular/core';
import { ChartType, ChartOptions,ChartDataSets } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import { MatSnackBar } from '@angular/material';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {formatDate} from '@angular/common';
import { AuthService } from '../auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { GeneralService } from '../general.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dist-pat-data-overview',
  templateUrl: './dist-pat-data-overview.component.html',
  styleUrls: ['./dist-pat-data-overview.component.css']
})
export class DistPatDataOverviewComponent implements OnInit {

  CHC_Count;
  PHC_Count;
  TH_Count;
  DH_Count;
  HWC_Count;
  MC_Count;
  PRISON_Count;
  maxDate;
  CHC_Submitted_Count;
  PHC_Submitted_Count;
  TH_Submitted_Count;
  DH_Submitted_Count;
  HWC_Submitted_Count;
  MC_Submitted_Count;
  Prison_Submitted_Count;


  CHC_Not_Submitted_Count;
  PHC_Not_Submitted_Count;
  TH_Not_Submitted_Count;
  DH_Not_Submitted_Count;

  reportingMonthyear;
  districtId = sessionStorage.getItem('districtId');

  name = 'Angular ' + VERSION.major;

  public pieChartOptionsCHC: ChartOptions = {
    responsive: true,
  };
  public pieChartLabelsCHC: Label[] = ['Submitted', 'Not Submitted'];
  public pieChartDataCHC: SingleDataSet = [50, 30];
  public pieChartTypeCHC: ChartType = 'pie';
  public pieChartLegendCHC = true;
  //public pieChartColorCHC: ChartDataSets[] = [{backgroundColor:['red','green']}];
  public pieChartPluginsCHC = [];

  public pieChartOptionsPHC: ChartOptions = {
    responsive: true,
  };
  public pieChartLabelsPHC: Label[] = ['Submitted', 'Not Submitted'];
  public pieChartDataPHC: SingleDataSet = [50, 30];
  public pieChartTypePHC: ChartType = 'pie';
  public pieChartLegendPHC = true;
  //public pieChartColorPHC: ChartDataSets[] = [{backgroundColor:['red','green']}];
  public pieChartPluginsPHC = [];

  public pieChartOptionsTH: ChartOptions = {
    responsive: true,
  };
  public pieChartLabelsTH: Label[] = ['Submitted', 'Not Submitted'];
  public pieChartDataTH: SingleDataSet = [50, 30];
  public pieChartTypeTH: ChartType = 'pie';
  public pieChartLegendTH = true;
  //public pieChartColorTH: ChartDataSets[] = [{backgroundColor:['red','green']}];
  public pieChartPluginsTH = [];

  public pieChartOptionsDH: ChartOptions = {
    responsive: true,
  };
  public pieChartLabelsDH: Label[] = ['Submitted', 'Not Submitted'];
  public pieChartDataDH: SingleDataSet = [50, 30];
  public pieChartTypeDH: ChartType = 'pie';
  public pieChartLegendDH = true;
  //public pieChartColorDH: ChartDataSets[] = [{backgroundColor:['red','green']}];
  public pieChartPluginsDH = [];

  constructor(private router: Router, @Inject(DOCUMENT) document, private route: ActivatedRoute,
  private homepageService: GeneralService, private snackBar: MatSnackBar, private authService: AuthService, private generalService: GeneralService,
  private spinn: NgxSpinnerService) { }

  ngOnInit() {
  }

  getPatDashboardData(reportingMonthyear){

    reportingMonthyear = formatDate(reportingMonthyear, 'yyyy-MM', 'en');
    this.reportingMonthyear = reportingMonthyear+"-01";

      this.getHWCDashboardData();
  }

  getHWCDashboardData(){
    this.spinn.show();

    const inputData = {
      reportmonthyear: this.reportingMonthyear,
      distId: this.districtId
    }
      
      this.authService.getPatientDataOverviewDist(inputData).subscribe(response => {
        
        // Facilities Count

        this.CHC_Count = response.json().chcCount;
        this.PHC_Count = response.json().phcCount;
        this.TH_Count = response.json().thCount;
        this.DH_Count = response.json().dhCount;
        this.HWC_Count = response.json().hwcCount;
        this.MC_Count = response.json().mcCount;
        this.PRISON_Count = response.json().prisonCount;

        // Submitted Count

        this.CHC_Submitted_Count = response.json().chcSubmitCount;
        this.PHC_Submitted_Count = response.json().phcSubmitCount;
        this.TH_Submitted_Count = response.json().thSubmitCount;
        this.DH_Submitted_Count = response.json().dhSubmitCount;
        this.HWC_Submitted_Count = response.json().hwcSubmitCount;
        this.MC_Submitted_Count = response.json().mcSubmitCount;
        this.Prison_Submitted_Count = response.json().prisonSubmitCount;

        // Not Submitted Count Calculation

        this.CHC_Not_Submitted_Count = this.CHC_Count - this.CHC_Submitted_Count;
        this.PHC_Not_Submitted_Count = this.PHC_Count - this.PHC_Submitted_Count;
        this.TH_Not_Submitted_Count = this.TH_Count - this.TH_Submitted_Count;
        this.DH_Not_Submitted_Count = 27 - 27;

        // Load Data to PIE chart

        this.pieChartDataCHC = [this.CHC_Submitted_Count, this.CHC_Not_Submitted_Count];
        this.pieChartDataPHC = [this.PHC_Submitted_Count, this.PHC_Not_Submitted_Count];
        this.pieChartDataTH = [this.TH_Submitted_Count, this.TH_Not_Submitted_Count];
        this.pieChartDataDH = [27, this.DH_Not_Submitted_Count];
         
          this.spinn.hide();
      }, (error) => {
          this.spinn.hide();
        this.snackBar.open(error.json().message, 'x', {
          duration: 5000,
        });
      });
  }

}
